__turbopack_context__.v({
  "content": "GalleryGrid-module-scss-module__1QeiCW__content",
  "gridContainer": "GalleryGrid-module-scss-module__1QeiCW__gridContainer",
  "header": "GalleryGrid-module-scss-module__1QeiCW__header",
  "mobileView": "GalleryGrid-module-scss-module__1QeiCW__mobileView",
});
